import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid, Typography
} from "@material-ui/core";
import SearchGrid from "../../../../../components/table/SearchGrid";

import useStyles from "./styles";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { useHistory } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";

import { PostDataAPI } from '../../../../../Services/APIService';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
//import DisbursementIcon from "../../../../../assets/img/icons/disbursement.svg";
import companyLogo from '../../../../../assets/img/common/Ellipse 10.png';

import envelopeIcon from '../../../../../assets/img/common/envelope-Regular.svg';
import mapMarkerIcon from '../../../../../assets/img/common/map-marker-Regular.svg';
import phoneIcon from '../../../../../assets/img/common/phone-Regular.svg';
import StarIcon from '@material-ui/icons/Star';
import CompanyImg from '../../../../../assets/img/BTDD.png';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import AddGrant from "./component/AddGrant";




function GrantReceived({ programData, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    let history = useHistory();

    const [isLoading, setIsLoading] = useState(false);

    const [granteeOrganization, setGranteeOrganization] = useState(
        [
            { Date: 'Oct 01, 2023', disbursedAmount: 300, modeOfPayment: 'check', attachment: 'Attachment Document', grantStatus: 'Pending', Notes: 'Impact our product', },
            { Date: 'Oct 01, 2023', disbursedAmount: 300, modeOfPayment: 'check', attachment: 'Attachment Document', grantStatus: 'Pending', Notes: 'Impact our product', },
            { Date: 'Oct 01, 2023', disbursedAmount: 300, modeOfPayment: 'check', attachment: 'Attachment Document', grantStatus: 'Pending', Notes: 'Impact our product', },
            { Date: 'Oct 01, 2023', disbursedAmount: 300, modeOfPayment: 'check', attachment: 'Attachment Document', grantStatus: 'Pending', Notes: 'Impact our product', }
        ]
    );


    const [openGrant, setOpenGrant] = useState(false);

    const openGrantDialog = () => {
        setOpenGrant(true);
    }

    const closeGrantDialog = () => {
        setOpenGrant(false);
    }

    const [isApproveClick, setIsApproveClick] = useState(false)
    const [isAuthorizationClick, setIsAuthorizationClick] = useState(false);


    const handleActionClick = (key, item) => {
        if (key == 'Details') {
            setIsApproveClick(true)
        }
        else if (key == 'Authorization') {
            setIsAuthorizationClick(true)
        }
        else {
            return ''
        }
    }
    const closeClick = () => {
        setIsAuthorizationClick(false);
        setIsApproveClick(false);

    };
    const [addNewCashDisbursement, setAddNewCashDisbursement] = useState(false
    );

    const addCashDisburs = () => {

        setAddNewCashDisbursement(true);
    };
    const closeCashDisbursement = () => {
        setAddNewCashDisbursement(false);
    };

    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(!isDataRefresh);
    }


    const [grantReceived, setGrantReceived] = useState();

    const loadAllCollection = () => {
        var params = {
            programId: programData.programId
        }
        PostDataAPI("fdngrantcollection/loadGrid", params).then((result) => {
            console.log(result);
            if (result.success && result.data != null) {
                setGrantReceived(result.data)
                handleDataRefresh()
            } else {
                setGrantReceived([]);
            }
        });
    };

    const handleSuccessClose = (message) => {
        loadAllCollection();
        showMessage("Success", message, "success", 3000);
        closeGrantDialog();
    }


    const addGrant = () => {
 
    }



    useEffect(() => {
  
        loadAllCollection()
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}

            <Grid row className={classes.container}>

                <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn} onClick={() => openGrantDialog()}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add Grant
                        </Button>
                    </div>
                </div>

            </Grid>

            <Grid row className={classes.container}>
                <SearchGrid
                    columns="GrantReceived"
                    list={grantReceived}
                    noRecordMsg="No record exists."
                    Icon={true}
                    isSearchAble={false}
                    isUpdate={isDataRefresh}
                    onActionClick={handleActionClick}
                />
            </Grid>


            {openGrant ?
                <AddGrant
                    dialogOpenClose={openGrantDialog}
                    handleClose={closeGrantDialog}
                    handleSuccessClose={handleSuccessClose}
                    programData={programData}
                />
                : null}


        </>
    )
}
export default withSnackbar(GrantReceived);